// const Botservice = 'http://192.168.0.13:7090/';
const Botservice = 'https://bot.dentagenix.com/';

export default Botservice;
